export default __webpack_public_path__ + "static/box-terms-conditions-953eea5ec31ddb3159d36db585e01e8a.png";